var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "custom-tooltip-container" }, [
    _c(
      "span",
      { staticClass: "custom-tooltip-trigger" },
      [_vm._t("triggerTooltip")],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "custom-tooltip flex-row" },
      [_vm._t("contentTooltip")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }